import { Button, Card, Image } from "antd";
import styled from "styled-components";

type StyledCardContainerProps = {
  $x: number;
  $y: number;
  $isBottom: boolean;
};

export const StyledCardContainer = styled.div.attrs<StyledCardContainerProps>(
  (props) => ({
    style: {
      left: `${props.$x}px`,
      top: `${props.$y}px`,
    },
  }),
)<StyledCardContainerProps>`
  position: absolute;
  transform: translate(-50%, -110%);
  z-index: 500;
  pointer-events: none;

  transform: translate(
    -50%,
    ${(props) => (props.$isBottom ? "0.625rem" : "-107%")}
  );

  transition: transform 0.3s ease-out;
`;

export const StyledCard = styled(Card).attrs({
  styles: {
    body: {
      padding: "0 0.75rem 0.75rem 0.75rem",
      paddingTop: 0,
      overflow: "hidden",
      height: "100%",
    },
    header: {
      borderBottom: "none",
      padding: "0 0.375rem",
    },
  },
})`
  width: 18.75rem;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.15);
  pointer-events: auto;

  .ant-modal-close {
    transition: none !important;
    top: 1rem;
    right: 1rem;

    overflow: hidden;

    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.25rem;
    height: 2.25rem;
    border-radius: 50%;
    color: ${({ theme }) => theme.colors.default} !important;

    background-color: transparent;
    transition:
      background-color 0.3s ease,
      color 0.3s ease;

    &:hover {
      background-color: ${({ theme }) => theme.colors.neutralLight} !important;
    }
  }

  .ant-modal-close-x,
  .anticon.anticon-close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1rem;
    height: 1rem;
  }

  .ant-card-head-wrapper,
  .ant-card-extra {
    height: 2rem;
  }

  .ant-card-head {
    min-height: 0 !important;
    height: 2rem;
  }

  svg {
    width: 1rem;
    height: 1rem;
  }

  button.ant-btn.ant-btn-circle {
    width: 2rem !important;
    height: 2rem !important;
    min-width: 2rem !important;
  }
`;

export const StyledCarouselContainer = styled.div`
  width: 17.125rem;
  height: 11.375rem;
  overflow: hidden;
  border-radius: 0.5rem;
`;

export const StyledImage = styled(Image)`
  display: block;
  width: 17.125rem !important;
  height: 11.375rem !important;
  object-fit: cover;
  border-radius: 0.5rem;
`;

export const StyledInfoContainer = styled.div`
  padding: 0.625rem 0 0.75rem 0;
`;

export const StyledHeader = styled.h3`
  font-size: 1.125rem;
  line-height: 1.2;
  margin-bottom: 0.25rem;
`;

export const StyledParagraph = styled.p`
  font-size: 0.875rem;
`;

export const StyledButton = styled(Button)`
  width: 100%;
  height: 2rem;
  font-size: 0.875rem;
  border-radius: 0.35rem;
`;
